import { urlHasComponent } from '@App/helpers/url'
import { Maybe } from '@Types'

export const canAmend = (amend: Maybe<boolean>): boolean =>
    amend || urlHasComponent('draft') || urlHasComponent('create-work')
